/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Text } from '@uhg-abyss/web/ui/Text';
import { find } from 'lodash';
import React, { useState } from 'react';

import {
  drawerStyle,
  platinumPopover,
} from '../../common/CheckBoxGroup/CheckBoxInfoPopover.styled';
import { useLagoon } from '../../hooks/useLagoon';
import {
  Constants,
  FILTER_INFO_POPOVER_CONFIG,
  FilterCollectionModel,
} from '../Constants';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { phoneOnly } from '../ConstantsStyles';

interface CheckBoxPopoverProps {
  filterModel: FilterCollectionModel;
}

export const CheckBoxPopover = ({ filterModel }: CheckBoxPopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const uiMessaging = useLagoon(Constants.LAGOON_TABLE.UI_MESSAGING)();

  // Get configuration for the specific filter model
  const config = FILTER_INFO_POPOVER_CONFIG[filterModel];

  // If no configuration exists for this filter model, don't render anything
  if (!config) {
    return null;
  }

  const popoverContent = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING[
      config.contentKey as keyof typeof ConstantsLagoon.UI_MESSAGING
    ],
  });

  const popoverInfoText = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING[
      config.infoTitleKey as keyof typeof ConstantsLagoon.UI_MESSAGING
    ],
  });

  const popoverTitleData = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING[
      config.popoverTitle as keyof typeof ConstantsLagoon.UI_MESSAGING
    ],
  });

  const title: string = popoverTitleData?.title;
  const mobileScreen = useMediaQuery(phoneOnly);

  const content = () => (
    <Flex
      alignItems="center"
      data-auto-testid="filter-info-icon-button"
      data-testid="filter-info-icon-button"
      onClick={() => setIsOpen(true)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsOpen(true);
        }
      }}
      role="button"
      tabIndex={0}
    >
      <IconSymbol icon="info" size={16} variant="outlined" />
      <Text
        css={{
          lineHeight: '18px',
          fontSize: '14px',
          color: '$core.color.brand.60 !important',
          paddingLeft: '8px',
          fontWeight: '600',
        }}
      >
        {popoverInfoText?.message}
      </Text>
    </Flex>
  );

  return (
    <React.Fragment>
      {!mobileScreen ? (
        <Popover
          content={popoverContent?.message}
          css={platinumPopover}
          data-testid="filter-info-icon-popover"
          onOpenChange={() => {
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          title={title}
          width={220}
        >
          {content()}
        </Popover>
      ) : (
        <React.Fragment>
          {content()}
          <Drawer
            css={drawerStyle}
            data-auto-testid="filter-info-icon-popover"
            data-testid="filter-info-icon-popover"
            header={title}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            position="right"
          >
            <div>{popoverContent?.message}</div>
          </Drawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
